export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// /~/d3-array/src/identity.js
// module id = hu4H
// module chunks = 0